export default "__VITE_ASSET__DdOK6DsG__"